export const getSelectButtonClass = (
  selected: boolean,
  theme: string
): string => {
  const defaultClass = ` fw-bold`
  const selectedClass = `bg-input bg-dark-subtle text-${theme === 'dark' ? 'light' : 'dark'} opacity-100`
  const notSelectedClass = `bg-light-subtle text-${theme === 'dark' ? 'light' : 'dark'}`
  return defaultClass + ' ' + (selected ? selectedClass : notSelectedClass)
}
